import { useLiveTrafficMap } from "../hooks/useLiveTrafficMap"

export const LiveTrafficMap = ({ center, staleTime, marker, zoom }) => {
  const { ref } = useLiveTrafficMap(center, { staleTime, marker, zoom })
  // Return a div element to hold the map
  return <div style={{ width: "100%", height: "100%" }} ref={ref} />
}
